import PropTypes from 'prop-types';

import { doctorStatusEnum } from 'modules/doctors/enums';

import {
  DoctorsHeaderWrapper,
  DoctorsHeaderFilterWrapper,
  DoctorsHeaderFilterItemWrapper,
  DoctorsHeaderFilterItem,
} from './DoctorsHeader.style';

const DoctorsHeader = ({ selectedStatusFilter, handleDoctorStatusFilterClick }) => {
  const doctorStatusFilterList = [
    { key: 0, name: 'All Doctors' },
    ...Object.keys(doctorStatusEnum)
      .filter(
        key =>
          typeof doctorStatusEnum[key] === 'string' || typeof doctorStatusEnum[key] === 'number',
      )
      .map(key => ({
        key: doctorStatusEnum[key],
        name: key,
      })),
  ];

  return (
    <DoctorsHeaderWrapper>
      <DoctorsHeaderFilterWrapper>
        {doctorStatusFilterList.map(doctorFilterItem => {
          const isFilterSelected = doctorFilterItem.key === selectedStatusFilter;

          return (
            <DoctorsHeaderFilterItemWrapper
              key={doctorFilterItem.key}
              selected={isFilterSelected}
              onClick={() => handleDoctorStatusFilterClick(doctorFilterItem.key)}
            >
              <DoctorsHeaderFilterItem>{doctorFilterItem.name}</DoctorsHeaderFilterItem>
            </DoctorsHeaderFilterItemWrapper>
          );
        })}
      </DoctorsHeaderFilterWrapper>
    </DoctorsHeaderWrapper>
  );
};

DoctorsHeader.propTypes = {
  selectedStatusFilter: PropTypes.number.isRequired,
  handleDoctorStatusFilterClick: PropTypes.func.isRequired,
};

export default DoctorsHeader;
